module.exports = __webpack_public_path__ + "media/images/cbs/logo-home-mobile-1cd49f7f5e5960baf1b53dc1381784d3.svg";